import React from 'react';
import { Button } from '../UiKit';
import { Auth as AwsAuth } from 'aws-amplify';
import { useLocation } from 'react-router-dom';
import { redirectToLogin } from '../utils/UtilFunctions';

const Auth = ({ title = 'Login' }) => {
  const { search, pathname } = useLocation();

  // create a redirection url with search and pathanme and then use encodeURIComponent to encode the url
  const redirectUrl = encodeURIComponent(`${pathname}${search}`);

  const handleLogin = () => {
    AwsAuth.federatedSignIn({
      provider: 'Google',
      customState: JSON.stringify({
        redirect: `${pathname}${search}`,
      }),
    });
  };

  return (
    <div className='loginBtn'>
      <Button
        title={title}
        size='compressed'
        onClick={() => {
          if (window.__allow_cognito_login__) {
            handleLogin();
          } else {
            redirectToLogin(redirectUrl);
          }
        }}
      />
    </div>
  );
};

export default Auth;
